module.exports = __webpack_public_path__ + "static/media/logo.8ca1b8d6.svg";